module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-114x1149f15795c6316bb86aad298523be5e547.png";